import { cn } from "@/lib/utils";
import type { IconProps } from "./Icon";
import { Icon, Path } from "./Icon";

/**
 * The Inbox header's overflow menu.
 *
 * It rests at whatever `@trycourier/courier-ui-inbox` draws its own overflow icon in — the
 * kit's `inbox.header.actions.button.icon.color`, which is `black[500]` in light and
 * `white[500]` in dark. The preview is meant to be the Inbox, so the icon inverts with the
 * mode the way the Inbox's does rather than sitting at one fixed gray in both.
 *
 * The color goes to `Path` as `color`, not as a raw `fill` prop: `Path` only skips its
 * `courier-fill-ring` theme class when it is given a `color`, and that class outranks a `fill`
 * attribute. Passing `fill` straight through left the icon painting `--ring` — #0085FF in dark —
 * whatever color was asked for.
 *
 * `color` still overrides, for a caller that wants something else.
 */
export const MoreMenuIcon = ({
  color = "currentColor",
  width = 14,
  height = 16,
  className,
  ...props
}: IconProps) => (
  <Icon
    {...props}
    width={width}
    height={height}
    className={cn("courier-inbox-overflow-icon", className)}
  >
    <Path
      d="M13.5 8C13.5 8.5625 13.1875 9.03125 12.75 9.3125C12.2812 9.59375 11.6875 9.59375 11.25 9.3125C10.7812 9.03125 10.5 8.5625 10.5 8C10.5 7.46875 10.7812 7 11.25 6.71875C11.6875 6.4375 12.2812 6.4375 12.75 6.71875C13.1875 7 13.5 7.46875 13.5 8ZM8.5 8C8.5 8.5625 8.1875 9.03125 7.75 9.3125C7.28125 9.59375 6.6875 9.59375 6.25 9.3125C5.78125 9.03125 5.5 8.5625 5.5 8C5.5 7.46875 5.78125 7 6.25 6.71875C6.6875 6.4375 7.28125 6.4375 7.75 6.71875C8.1875 7 8.5 7.46875 8.5 8ZM2 9.5C1.4375 9.5 0.96875 9.21875 0.6875 8.75C0.40625 8.3125 0.40625 7.71875 0.6875 7.25C0.96875 6.8125 1.4375 6.5 2 6.5C2.53125 6.5 3 6.8125 3.28125 7.25C3.5625 7.71875 3.5625 8.3125 3.28125 8.75C3 9.21875 2.53125 9.5 2 9.5Z"
      color={color}
    />
  </Icon>
);

export default MoreMenuIcon;
